import { Lang } from '@ahd/shared/types/ahd-fleet-api/lang';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import deLocalesCustomer from './customerTexts/de-DE';
import enLocalesCustomer from './customerTexts/en-US';
import frLocalesCustomer from './customerTexts/fr-FR';
import { type TranslationsCustomer } from './customerTexts/translations';
import deLocales from './de-DE';
import enLocales from './en-US';
import deLocalesErrors from './errors/de-DE';
import enLocalesErrors from './errors/en-US';
import frLocalesErrors from './errors/fr-FR';
import { type TranslationsErrors } from './errors/translations';
import frLocales from './fr-FR';
import { type Translations } from './translations';

declare module 'i18next' {
    interface CustomTypeOptions {
        defaultNS: 'common';
        resources: {
            common: Translations;
            customer: TranslationsCustomer;
            errors: TranslationsErrors;
        };
    }
}

i18n.use(initReactI18next).init({
    defaultNS: 'common',
    detection: {
        caches: [],
    },
    fallbackLng: Lang.enUs,
    interpolation: {
        escapeValue: false,
    },
    lng: Lang.enUs,
    load: 'currentOnly',
    ns: ['common'],
    resources: {
        'de-DE': { common: deLocales, customer: deLocalesCustomer, errors: deLocalesErrors },
        'en-US': { common: enLocales, customer: enLocalesCustomer, errors: enLocalesErrors },
        'fr-FR': { common: frLocales, customer: frLocalesCustomer, errors: frLocalesErrors },
    },
    supportedLngs: [Lang.deDE, Lang.enUs, Lang.frFr],
});

export default i18n;
